import { redstone as defaultRedstone } from "@latticexyz/common/chains";
import { createWagmiConfig } from "@latticexyz/entrykit/internal";
import { chainId } from "@permutation-city/common";
import { http, type Chain, webSocket } from "viem";
import { anvil } from "viem/chains";

const redstone = {
  ...defaultRedstone,
  rpcUrls: {
    ...defaultRedstone.rpcUrls,
    wiresaw: {
      http: ["https://wiresaw.redstonechain.com"],
      webSocket: ["wss://wiresaw.redstonechain.com"],
    },
  },
  indexerUrl: "https://indexer.alpha.dustproject.org",
} as const;

export const chains = [anvil, redstone] as const satisfies Chain[];

export const transports = {
  [anvil.id]: http(),
  [redstone.id]: webSocket(),
} as const;

export const wagmiConfig = createWagmiConfig({
  chainId,
  // TODO: swap this with another default project ID or leave empty
  walletConnectProjectId: "14ce88fdbc0f9c294e26ec9b4d848e44",
  appName: document.title,
  chains,
  transports,
  pollingInterval: {
    [anvil.id]: 2000,
    [redstone.id]: 2000,
  },
});
